import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import SendNotification from "./sendNotification";
import SendEmailNotification from "./sendEmailNotification";
import { cancelNotificationTask, createNotificationTask, createEmailNotificationTask, getNotificationTask, searchNotifications, searchNotificationsByUserId, clearLastNotificationDetails } from "../../action/notification";
import FindNotification from "./findNotification";
import TemplateList from "./templates/TemplateList";
import NotificationTaskDetailsPage from "./taskStatistics/NotificationTaskDetailsPage";
import {
  Box,
} from "@mui/material";
import { SectionHeading, LabelText } from "../Common/Typography/AppTypography";
import Dialog from "../Common/Dailog/Dailog";
import { getNotificationPermission, notificationTemplateTypes } from "./notificationConstant";
import AppTabs from "../Common/Tabs/AppTabs";

const NotificationManagement = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    notificationStore,
    getNotificationTask,
    createNotificationTask,
    createEmailNotificationTask,
    cancelNotificationTask,
    searchNotificationsByUserId,
    searchNotifications,
    userData,
    tenantData,
    userRoles,
    userLevel,
    clearLastNotificationDetails,
}) => {
    const [activeTab, setActiveTab] = React.useState(0)
    const [dialog, setDialog] = useState(false);
    const [dialogTab, setDialogTab] = useState(0);
    const [dialogContents, setDialogContents] = useState({ title: "", data: {}, content: "" })
    const [detailsView, setDetailsView] = useState(null);
    const [detailsTab, setDetailsTab] = useState(0);
    const detailsModeRef = React.useRef(false);
    const [loadedTemplate, setLoadedTemplate] = useState(null);

    const isDetailsContent = (contents) =>
      String(contents?.content || "").toLowerCase().includes("notificationdetails");

    const handleSetDialogContents = (contents) => {
      if (isDetailsContent(contents)) {
        detailsModeRef.current = true;
        setDetailsView(contents);
        setDetailsTab(0);
        return;
      }
      detailsModeRef.current = false;
      setDialogContents(contents);
    };

    const handleSetDialog = (open) => {
      if (open && detailsModeRef.current) return;
      setDialog(open);
    };

    const handleSetDialogTab = (tab) => {
      if (detailsModeRef.current || detailsView) {
        setDetailsTab(tab);
        return;
      }
      setDialogTab(tab);
    };

    const closeDetailsView = () => {
      detailsModeRef.current = false;
      setDetailsView(null);
      setDetailsTab(0);
    };

    const tabs = [
        { label: "Push Notification", permission: 'sendNotification' },
        { label: "Email Notification (beta)", permission: 'sendNotification' },
        { label: "Templates", permission: 'notificationTemplates' },
        { label: "Search Notification", permission: 'getNotificationTask' },
    ]
    const [availableTabs, setAvailableTabs] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

    useEffect(() => {
        const visibleTabs = tabs?.filter(t => {
            return getNotificationPermission(userRoles, t?.permission)
        })?.map(t => t?.label)
        setAvailableTabs(visibleTabs)
        setSelectedTab(visibleTabs[0])
    }, [userRoles])

    const selectTabByLabel = (label) => {
        const index = availableTabs.indexOf(label);
        if (index >= 0) {
            setActiveTab(index);
            setSelectedTab(label);
        }
    };

    const handleLoadTemplateFromList = (template) => {
        if (!template) return;
        if (template.notificationType === notificationTemplateTypes.push.value) {
            setLoadedTemplate({ ...template, loadedAt: Date.now() });
            selectTabByLabel("Push Notification");
            return;
        }
        if (template.notificationType === notificationTemplateTypes.email.value) {
            setLoadedTemplate({ ...template, loadedAt: Date.now() });
            selectTabByLabel("Email Notification (beta)");
        }
    };

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            {(!getNotificationPermission(userRoles, 'sendNotification') && !(getNotificationPermission(userRoles, 'getNotificationTask') || getNotificationPermission(userRoles, 'getNotificationList'))) ? (
                <Box sx={{ py: 2 }}>
                  <SectionHeading>Insufficient Permission</SectionHeading>
                </Box>
            ) : detailsView ? (
                <NotificationTaskDetailsPage
                    title={detailsView.title}
                    content={detailsView.content}
                    data={detailsView.data}
                    tab={detailsTab}
                    onTabChange={setDetailsTab}
                    onBack={closeDetailsView}
                />
            ) : (
                <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, marginTop: 0, boxSizing: "border-box" }}>
                    <AppTabs
                        value={activeTab}
                        onChange={(e, newValue) => {
                            clearLastNotificationDetails?.();
                            setActiveTab(newValue)
                            setSelectedTab(availableTabs[newValue])
                        }}
                        tabs={availableTabs?.map((label) => ({ label }))}
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{ marginTop: 0 }}
                        tabMinWidth="auto"
                    />
                    {
                        selectedTab === "Push Notification" ?
                            <SendNotification
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                notificationStore={notificationStore}
                                createNotificationTask={createNotificationTask}
                                getNotificationTask={getNotificationTask}
                                setDialog={handleSetDialog}
                                setDialogContents={handleSetDialogContents}
                                setDialogTab={handleSetDialogTab}
                                userLevel={userLevel}
                                loadedTemplate={loadedTemplate}
                            ></SendNotification>
                            : selectedTab === "Email Notification (beta)" ?
                            <SendEmailNotification
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                notificationStore={notificationStore}
                                createEmailNotificationTask={createEmailNotificationTask}
                                getNotificationTask={getNotificationTask}
                                setDialog={handleSetDialog}
                                setDialogContents={handleSetDialogContents}
                                setDialogTab={handleSetDialogTab}
                                loadedTemplate={loadedTemplate}
                            ></SendEmailNotification>
                            : selectedTab === "Templates" ?
                            <TemplateList onLoadTemplate={handleLoadTemplateFromList} />
                            :
                            <FindNotification
                                notificationData={notificationStore}
                                getNotificationTask={getNotificationTask}
                                searchNotificationsByUserId={searchNotificationsByUserId}
                                allowedCountries={allowedCountries}
                                searchNotifications={searchNotifications}
                                setAlert={setAlert}
                                userData={userData}
                                tenantData={tenantData}
                                setDialog={handleSetDialog}
                                setDialogContents={handleSetDialogContents}
                                setDialogTab={handleSetDialogTab}
                                userRoles={userRoles}
                            ></FindNotification>
                    }
                </Box>
            )}
            <Dialog
                open={dialog}
                onClose={() => setDialog(false)}
                title={dialogContents?.title}
                maxWidth="md"
                fullWidth
                showCloseButton
                sx={{ zIndex: "2400 !important" }}
                PaperProps={{
                    sx: {
                        marginTop: { xs: "72px", sm: "72px", md: 0 },
                        maxHeight: { xs: "calc(100vh - 88px)", sm: "calc(100vh - 88px)", md: "90vh" },
                    },
                }}
                titleSx={{ backgroundColor: "#f4f4f4", fontSize: "16px !important" }}
                contentSx={{ overflowY: "visible" }}
                actions={[
                    { label: "Cancel", variant: "ghost", onClick: () => setDialog(false) },
                    {
                        label: "Confirm",
                        variant: "primary",
                        onClick: () => {
                            setDialog(false);
                            cancelNotificationTask(dialogContents?.data?.fullTaskId, () => {
                                getNotificationTask(dialogContents?.data?.fullTaskId);
                            });
                        },
                    },
                ]}
            >
                <LabelText>
                    {`Are you sure you want to cancel the notification with task ID ${dialogContents?.data?.fullTaskId} ?`}
                </LabelText>
            </Dialog>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    allowedCountries: state.auth.allowedCountries,
    userLevel: state.auth.userLevel,
    userRoles: state.auth.roles,
    notificationStore: state.notification,
    userData: state.user,
    tenantData: state?.tenant?.tenantInfo
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    createNotificationTask: (requestData) => dispatch(createNotificationTask(requestData)),
    createEmailNotificationTask: (requestData) => dispatch(createEmailNotificationTask(requestData)),
    getNotificationTask: (taskId, action = "updateGetNotification") => dispatch(getNotificationTask(taskId, action)),
    searchNotificationsByUserId: (userId, pgIndex, severity = null, pgSize) =>
        dispatch(searchNotificationsByUserId(userId, pgIndex, severity, pgSize)),
    searchNotifications: (searchBy, searchStr, pgIndex, tenantId, pgSize) =>
        dispatch(searchNotifications(searchBy, searchStr, pgIndex, tenantId, pgSize)),
    cancelNotificationTask: (taskId, cb) => dispatch(cancelNotificationTask(taskId, cb)),
    clearLastNotificationDetails: () => dispatch(clearLastNotificationDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationManagement);